import * as DateFns from 'date-fns';

import { routeToSpecificScope } from '../../helpers/helpersts';
import * as TYPE from '../types';
import { SERVER } from '../../config/server.config';
import { requestData } from '../../config/services/datasets';
import { addLoadingFlag, changeMessageLoading, subLoadingFlag } from './loading';
import { SCOPE } from '../../config/constants';
import { ProfilesState, ProfileAction, ProfileType, Drill } from '../types';
import { Dispatch } from 'redux';
import { RootState } from '../reducers';
import { AppThunk } from '../../config/commonTypes';

export const updateProfiles = (data: ProfilesState | [])  => {
  return {
    type: ProfileAction.UPDATE_PROFILES,
    data: data
  };
};

const getProfilesByTeamId = (results: ProfileType[]) => {
  const profiles: ProfilesState = {};
  results.forEach(result => {
    const teamProfile = profiles[result.teamId] || [];
    teamProfile.push(result);
    profiles[result.teamId] = teamProfile;
  });
  const lsProfiles = { data: profiles, ts: new Date() };
  localStorage.setItem('profiles', JSON.stringify(lsProfiles));
  return profiles;
};

export const getProfiles = (forcedScope?: string, isMobile?: boolean) => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    const path = getState().router.location.pathname;
    const scope = forcedScope || routeToSpecificScope(path);
    dispatch(addLoadingFlag(scope));
    const results = await requestData(SERVER.PROFILES(isMobile));
    const specificScope = routeToSpecificScope(path);
    if (results && results.length) {
      const profiles = getProfilesByTeamId(results);
      dispatch(updateProfiles(profiles));
    } else {
      dispatch(updateProfiles([]));
      dispatch(changeMessageLoading(scope, 'No data matches your specified criteria'));
    }
    dispatch(subLoadingFlag(scope));
  };
};

const loadProfilesFromLS = () => {
  const { ts, data } = JSON.parse(localStorage.getItem("profiles") ?? "{}");
  if (ts) {
    const tsDifMins = DateFns.differenceInMinutes(new Date(), DateFns.parseISO(ts));
    return tsDifMins < 5 && data; // call a new fetch each >= 5 mins
  }
  return null;
};

// get the profiles for the App.js mode
export const loadProfiles = (isMobile: boolean): AppThunk => {
  return async (dispatch) => {
    const lsResults = loadProfilesFromLS();
    if (lsResults) {
      dispatch(updateProfiles(lsResults));
    } else {
      dispatch(getProfiles(SCOPE.PROFILES.PAGE, isMobile));
    }
  };
};

export const createProfile = (profile: ProfileType, periods: Drill[]): AppThunk => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    const teamId = profile.teamId;
    const body = { ...profile, drills: periods };
    const request = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    };
    dispatch(addLoadingFlag(scope));
    const response = await requestData(SERVER.CREATE_PROFILE(profile.league, teamId), request);
    if (response) {
      dispatch(getProfiles());
    }
    dispatch(subLoadingFlag(scope));
  };
};

export const updateProfile = (profile: ProfileType, periods: Drill[]): AppThunk => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    const teamId = profile.teamId;
    const bodyProfile = { ...profile };
    delete bodyProfile._id;
    const body = { ...bodyProfile, drills: periods, lastModified: new Date().getTime() };
    const request = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    };
    dispatch(addLoadingFlag(scope));
    const response = await requestData(SERVER.EDIT_PROFILE(profile._id, profile.league, teamId), request);
    if (response) {
      dispatch(getProfiles());
    }
    dispatch(subLoadingFlag(scope));
  };
};

export const deleteProfile = (profile: ProfileType): AppThunk => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    const request = {
      method: 'DELETE',
      body: JSON.stringify({})
    };
    dispatch(addLoadingFlag(scope));
    await requestData(SERVER.DELETE_PROFILE(profile._id, profile.league, profile.teamId), request);
    dispatch(getProfiles());
    dispatch(subLoadingFlag(scope));
  };
};
